import { useContext } from 'react'
import { LinkageContext } from './linkageProvider'

export const useLinkage = () => useContext(LinkageContext)
